<app-header></app-header>
<app-solutions-hero></app-solutions-hero>
<app-solutions-products></app-solutions-products>
<app-solutions-test></app-solutions-test>
<app-footer></app-footer>
